/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetOrderbookStatsOptions,
  GetOrderbookStatsStatus200,
  GetOrderbookStatsStatus204,
  GetOrderbookStatsStatus400,
  GetOrderbookStatsStatus404,
  GetOrderbookStatsStatus500,
} from '../types/GetOrderbookStats'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getOrderbookStats } from '../clients/getOrderbookStats'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getOrderbookStatsQueryKey = ({ path }: Omit<GetOrderbookStatsOptions, 'headers'>) =>
  [{ url: '/v1/orderbooks/:order_book_id/stats', params: path }] as const

type GetOrderbookStatsQueryKey = ReturnType<typeof getOrderbookStatsQueryKey>

export function getOrderbookStatsQueryOptions(
  { path }: GetOrderbookStatsOptions,
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getOrderbookStatsQueryKey({ path })
  return queryOptions<
    GetOrderbookStatsStatus200 | GetOrderbookStatsStatus204,
    ResponseErrorConfig<
      GetOrderbookStatsStatus400 | GetOrderbookStatsStatus404 | GetOrderbookStatsStatus500
    >,
    GetOrderbookStatsStatus200 | GetOrderbookStatsStatus204,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getOrderbookStats({
        ...config,
        path,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get orderbook stats
 * {@link /v1/orderbooks/:order_book_id/stats}
 */
export function useGetOrderbookStats<
  TData = GetOrderbookStatsStatus200 | GetOrderbookStatsStatus204,
  TQueryData = GetOrderbookStatsStatus200 | GetOrderbookStatsStatus204,
  TQueryKey extends QueryKey = GetOrderbookStatsQueryKey,
>(
  { path }: { path: GetOrderbookStatsOptions['path'] | (() => GetOrderbookStatsOptions['path']) },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetOrderbookStatsStatus200 | GetOrderbookStatsStatus204,
        ResponseErrorConfig<
          GetOrderbookStatsStatus400 | GetOrderbookStatsStatus404 | GetOrderbookStatsStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { path: typeof path === 'function' ? path() : path }
  const queryKey = resolvedOptions?.queryKey ?? getOrderbookStatsQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getOrderbookStatsQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetOrderbookStatsStatus400 | GetOrderbookStatsStatus404 | GetOrderbookStatsStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
